/**
 * Do not edit directly
 * Generated on Fri, 04 Sep 2026 03:50:37 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
